<template lang="html">
  	<div id="page__search-toolbar" class="toolbar-search">
		<z-date class="toolbar-search__input" light ref="datefrom" v-model="filter.dateFrom" placeholder="Начальная дата"></z-date>
		<z-date class="toolbar-search__input" light ref="dateto" v-model="filter.dateTo" placeholder="Конечная дата"></z-date>
		<z-button fit-content no-margin v-on:click="doFilter" v-bind:disabled="!filter.dateFrom || !filter.dateTo"> Показать </z-button>
		<z-icon-button v-bind:icon="['fa', 'xmark']" rounded danger-light v-on:click="onReset" ></z-icon-button>
  	</div>
</template>
<script>
	import ZButton from '@/components/ZButton.vue';
	import ZDate from '@/components/ZDate';
	import ZIconButton from '@/components/ZIconButton.vue';
	export default {
		components: { ZDate, ZIconButton, ZButton },
		data() {
			return {
				filter: {
					dateFrom: null,
					dateTo: null
				},
				filterDefault: {
					dateFrom: null,
					dateTo: null
				}
			}
		},
		methods: {
			/**
			 * Сброс фильтра
			 */
			onReset() {
                this.filter = Object.assign({}, this.filterDefault);
                this.doFilter();
            },
			/**
			 * Фильтр
			 */
			doFilter() {
				let filter = {model: [["created_at", ">=", this.moment(this.filter.dateFrom).format('YYYY-MM-DD')], "and", ["created_at", "<=", this.moment(this.filter.dateTo).format('YYYY-MM-DD')]]};
				this.$router.push({
					name: this.$route.name,
					params: this.$route.params,
					query: {filter: JSON.stringify(filter)}
				});
			},
		}
	}
</script>




// WEBPACK FOOTER //
// SearchToolbar.vue?6a8033f8